import { render, staticRenderFns } from "./HomeContents.vue?vue&type=template&id=0c036678&scoped=true"
import script from "./HomeContents.vue?vue&type=script&lang=js"
export * from "./HomeContents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c036678",
  null
  
)

export default component.exports